import i18n from "app/config/translation/i18n";
import { PrstsCdType } from "app/model/common/code";
import { ButtonColor } from "app/components/arc/ArcButton";
import { VariablesConstant } from "app/constants/variables";

export class CodeUtil {
  public static trdKndCdConvert(code: number): string {
    if (code) {
      return i18n.t(`common.code.trdKndCd.${code}`);
    } else {
      return "";
    }
  }
  public static rpdcCodeConvert(code: number): string {
    if (code) {
      return i18n.t(`common.code.rpdcCd.${code}`);
    } else {
      return "";
    }
  }

  public static convertPrstsCd(code: number): string {
    switch (code) {
      case 1:
        return "PROCESS";
      case 2:
        return "CONFIRM";
      case 3:
        return "REJECT";
      case 4:
        return "COMPLETE";
      default:
        return "";
    }
  }

  public static prstsCodeConvert(code: number): string {
    let codeNm = CodeUtil.convertPrstsCd(code);
    if (codeNm) {
      return i18n.t(`common.code.prstsCd.${codeNm}`);
    } else {
      return "";
    }
  }

  public static prstsCodeWPConvert(code: PrstsCdType): string {
    if (code) {
      return i18n.t(`common.code.prstsCdWP.${code}`);
    }
    return "";
  }

  public static trdAplStsCodeConvert(code: number): string {
    if (code || code === 0) {
      return i18n.t(`common.code.trdAplStsCd.${code}`);
    } else {
      return "";
    }
  }

  public static trdAplStsBadgeClass(code: number): string {
    switch(code) {
      case 0: // 등록
      case 1: // 요청
        return 'p-badge5';
      case 2: // 협상
        return 'p-badge2';
      case 3:
      case 4: // 거절, 포기
        return 'p-badge4';
      case 5: // 수락
        return 'p-badge3';
      case 6:
      case 7: // 계약서 전송 및 진행
        return 'p-badge2';
      case 8: // 계약 취소
        return 'p-badge4';
      case 9: // 계약 완료
        return 'p-badge1';
      default: return "";
    }
  }
  public static trdAplStsCodeColor(code: number): string {
    switch(code) {
      case 0: // 등록
        return ButtonColor.btn1;
      case 1: // 요청
        return ButtonColor.btn9;
      case 2: // 협상
        return ButtonColor.btn11;
      case 3:
      case 4: // 거절, 포기
        return ButtonColor.btn3;
      case 5: // 수락
        return ButtonColor.btn8;
      case 6:
      case 7: // 계약서 전송 및 진행
        return ButtonColor.btn7;
      case 8: // 계약 취소
        return ButtonColor.btn3;
      case 9: // 계약 완료
        return ButtonColor.btn2;
      default: return "";
    }
  }

  public static cntrPrgsStsCodeConvert(code: number): string {
    if (code) {
      return i18n.t(`common.code.cntrPrgsStsCd.${code}`);
    } else {
      return "";
    }
  }

  public static cntrCdCodeConvert(code: number): string {
    if (code) {
      return i18n.t(`common.code.cntrCd.${code}`);
    } else {
      return '';
    }
  }
  public static cntrOtranYnConvert(code: string): string {
    if (code) {
      return i18n.t(`cb.cntr.otranYn.${code}`);
    }
    return "";
  }

  public static reqdCdCodeConvert(code: number): string {
    if (code) {
      return i18n.t(`common.code.emksReqdCd.${code}`);
    }
    return "";
  }

  public static makeCpCommonCodeOptions(data: any[]) {
    return data.map((item: any) => ({
      label: item.comCdExpl,
      value: item.comCd,
    }));
  }

  public static makeUppoCommonCodeOptions(data: any[]) {
    return data.map((item: any) => ({
      label: item.comCdExpl,
      value: item.comCd,
      uppoComCd: item.uppoComCd,
    }));
  }

  public static makeCpUnitOptions(data: any[]) {
    return data.map((item: any) => ({
      label: item.unitNm,
      value: item.crbnEmsnActvUnitId,
      cnvrUnitNm: item.cnvrUnitNm,
      enrgUnitNm: item.enrgUnitNm,
    }));
  }

  public static cpReduceGoalCategoryConvert(code: number) {
    if (code) {
      return i18n.t(`cp.roadMap.reduceGoal.goalType.${code}`);
    } else {
      return "";
    }
  }

  public static billReqdCdConvert(code: number): string {
    if (code) {
      return i18n.t(`common.code.emksReqdCd.${code}`);
    } else {
      return "";
    }
  }

  public static billReqdLdspTrdCdConvert(code: number): string {
    if (code) {
      return i18n.t(`common.code.emksLdspTrdClCd.${code}`);
    } else {
      return "";
    }
  }

  public static sysOpenApiClCdConverter(code: string): string {
    if (code) {
      return i18n.t(`common.code.emksApiClCd.${code}`);
    } else {
      return "";
    }
  }

  public static convertEmksCntrKndCd(code: string): string {
    if (code) {
      const find = VariablesConstant.EMKS_CNTR_KND_CD.find(f => code === f.value);
      return find ? find.label : '';
    } else {
      return "";
    }
  }

  public static convertEmksIndsCmplxClCd(code: string | undefined, defaultValue?: string): string {
    if (code) {
      switch (code) {
        case 'INDS001': return '1단지';
        case 'INDS002':
        case 'INDS003': return '2·3단지';
        case 'INDS004': return '4단지';
        case 'INDS005': return '5단지';
        default: return '';
      }
    } else {
      return defaultValue ?? '';
    }
  }
}
